import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export type LogoType = 'icon' | 'custom'

export interface BrandingState {
  systemName: string
  shortName?: string
  primaryColor: string
  secondaryColor: string
  logoUrl: string
  iconUrl?: string
  faviconUrl: string
  pwaIconUrl?: string
  logoType: LogoType
  updateBranding: (newBranding: Partial<Omit<BrandingState, 'updateBranding' | 'resetBranding'>>) => void
  resetBranding: () => void
}

const DEFAULT_BRANDING = {
  systemName: 'GSP Assessoria',
  shortName: 'GSP Assessoria',
  primaryColor: '#d4af37',
  secondaryColor: '#f3e5ab',
  logoUrl: '',
  iconUrl: '',
  faviconUrl: '',
  pwaIconUrl: '',
  logoType: 'icon' as LogoType,
}

export const useBrandingStore = create<BrandingState>()(
  persist(
    (set) => ({
      ...DEFAULT_BRANDING,
      updateBranding: (newBranding) => set((state) => ({ ...state, ...newBranding })),
      resetBranding: () => set((state) => ({ ...state, ...DEFAULT_BRANDING })),
    }),
    {
      name: 'gsp-branding',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        if (state && state.systemName === 'GSP Core') {
          state.systemName = 'GSP Assessoria'
        }
      }
    }
  )
)
